import httpService from "./http.service"

const serviceService = {
  getServices: async () => {
    const { data } = await httpService.get("api/services/")
    return data
  },
  getServicesManagement: async ({
    limit,
    offset,
    signal,
    withTotal = false,
    qId,
    qName,
    qPrice,
    qDuration,
    qActive,
    qComplexes,
    sort,
    sortDir,
  } = {}) => {
    const params = {}
    if (limit != null) params.limit = limit
    if (offset != null) params.offset = offset
    if (withTotal) params.with_total = 1
    if (qId) params.q_id = qId
    if (qName) params.q_name = qName
    if (qPrice) params.q_price = qPrice
    if (qDuration) params.q_duration = qDuration
    if (qActive) params.q_active = qActive
    if (qComplexes) params.q_complexes = qComplexes
    if (sort) params.sort = sort
    if (sortDir) params.sort_dir = sortDir
    const { data } = await httpService.get("api/services/management/", {
      params,
      signal,
    })
    return data
  },
  getServiceById: async (serviceId) => {
    const { data } = await httpService.get(`api/services/service/${serviceId}/`)
    return data
  },
  getComplexes: async () => {
    const { data } = await httpService.get("api/services/complexes")
    return data
  },
  getComplexesManagement: async ({
    limit,
    offset,
    signal,
    withTotal = false,
    qId,
    qName,
    sort,
    sortDir,
  } = {}) => {
    const params = {}
    if (limit != null) params.limit = limit
    if (offset != null) params.offset = offset
    if (withTotal) params.with_total = 1
    if (qId) params.q_id = qId
    if (qName) params.q_name = qName
    if (sort) params.sort = sort
    if (sortDir) params.sort_dir = sortDir
    const { data } = await httpService.get("api/services/complexes/management/", {
      params,
      signal,
    })
    return data
  },
  getComplexById: async (complexId) => {
    const { data } = await httpService.get(`api/services/complex/${complexId}/`)
    return data
  },
  createComplex: async (payload) => {
    const { data } = await httpService.post("api/services/complex/", payload)
    return data
  },
  updateComplex: async (complexId, payload) => {
    const { data } = await httpService.patch(`api/services/complex/${complexId}/`, payload)
    return data
  },
  deleteComplex: async (complexId) => {
    const { data } = await httpService.delete(`api/services/complex/${complexId}/`)
    return data
  },
  deleteComplexesBulk: async (ids) => {
    const { data } = await httpService.post("api/services/complexes/bulk-delete/", { ids })
    return data
  },
  createService: async (payload) => {
    const { data } = await httpService.post("api/services/", payload)
    return data
  },
  updateService: async (serviceId, payload) => {
    const { data } = await httpService.patch(`api/services/service/${serviceId}/`, payload)
    return data
  },
  deleteService: async (serviceId) => {
    const { data } = await httpService.delete(`api/services/service/${serviceId}/`)
    return data
  },
  deleteServicesBulk: async (ids) => {
    const { data } = await httpService.post("api/services/bulk-delete/", { ids })
    return data
  },
}

export default serviceService
